var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentToUse,{key:_vm.reportRoute,tag:"component",attrs:{"config":_vm.getExternalBIReport.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }